import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { TextFilterCell } from "./TextFilterCell"

type TextValue = string | null
type TextFilterValue = string | null

export abstract class TextFilterDef extends BaseFilterDef<TextValue, TextFilterValue> {
	abstract readonly icon: ReactNode
	abstract readonly label: string
	readonly defaultFilterValue: TextFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: TextValue): _value is string | null => true,
			isFilterValueValid: (_filterValue: TextFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (_value: TextValue): _value is string | null => true,
			isFilterValueValid: (_filterValue: TextFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: TextValue): value is string => value !== null,
			isFilterValueValid: (filterValue: TextFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: TextValue): value is string => value !== null,
			isFilterValueValid: (filterValue: TextFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<TextFilterDef>): ReactNode {
		return <TextFilterCell key={props.filter.id} {...props} />
	}
}
